import { zoomOutIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const ZoomOut = createIcon({
  displayName: 'ZoomOut',
  paths: [
    'M469.333 682.667c-117.821 0-213.333-95.514-213.333-213.333s95.513-213.333 213.333-213.333c117.82 0 213.333 95.513 213.333 213.333s-95.514 213.333-213.333 213.333zM469.333 768c67.089 0 129.011-22.118 178.871-59.465l112.499 112.499c16.64 16.64 43.648 16.64 60.331 0 16.64-16.683 16.64-43.691 0-60.331l-112.499-112.499c37.346-49.86 59.465-111.782 59.465-178.871 0-164.949-133.717-298.667-298.667-298.667s-298.667 133.718-298.667 298.667c0 164.949 133.718 298.667 298.667 298.667zM384 426.667c-23.564 0-42.667 19.102-42.667 42.667s19.103 42.667 42.667 42.667h170.667c23.565 0 42.667-19.102 42.667-42.667s-19.102-42.667-42.667-42.667h-170.667z'
  ],
  canvasPaths: canvasIconPaths(zoomOutIcon)
})
